var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.779297,
    width: 26.5214,
    height: 28,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3170_2878",
    transform: "matrix(0.0219948 0 0 0.0208333 -0.0278754 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3170_2878",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABPklEQVR4nO2ZMUpEMRBAs6illdWiruWKnffwAoJYeIettfQQXsBFsbOxsF1t9Q6CqLh/UbB6MrBiiP/LN7rJBOe1M5B5mSE/nzhnGIahFmAVOAEq0lMBZ0D/N8U/kp8nqSVGQHZeC8MYgRxj08Q4RkAVzgS+cgucAjcU2IGBl9cB9ksSuJeig9x54KUUgbua3DlgUoqAsBfkDpgx7o8FhEvgCLgmAW4GAklxJvDJpGXHNmpyroBzYAvoAgvAGnAAvFGAwM43622rF2ix5oV6AWAJ2GyI7aoWkMLlajyNH9bE17ULyOXvg1f5ggfxRe0CoyBnOYh3SjhGfXpt1zUBD+uAR89GqAmasRHKPUJZcCaQGfcfO1Chh+cYAXlc0MJxjEB/+riQmwdg5ccC3ivN0PsJSclYdj66eMMwDJeCd8rn2sEF3NgEAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2c607d2f1482ea1cedf6c3c412611ec9.svg";
export { ForwardRef as ReactComponent };